import { render, staticRenderFns } from "./companyInfo.vue?vue&type=template&id=2c9afc14&scoped=true"
import script from "./companyInfo.vue?vue&type=script&lang=js"
export * from "./companyInfo.vue?vue&type=script&lang=js"
import style0 from "./companyInfo.vue?vue&type=style&index=0&id=2c9afc14&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9afc14",
  null
  
)

export default component.exports